<template>
  <b-overlay :show="getting" class="rounded" opacity="0.2">
    <b-card no-body class="p-0">
      <div class="p-1">
        <div class="row">
          <div class="col-md-2 mb-1 mb-md-0">
            <v-select-list v-model="vault" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
          </div>
          <div class="col-md-2 mb-1 mb-md-0">
            <v-date-picker v-model="startDate" placeholder="Başlangıç Tarihi"/>
          </div>
          <div class="col-md-2 mb-1 mb-md-0">
            <v-date-picker v-model="endDate" placeholder="Bitiş Tarihi"/>
          </div>
          <div class="col-md-2 mb-1 mb-md-0">
              <v-select-list :options="types" v-model="type" multiple label="name" placeholder="İşlem Tipi"></v-select-list>
          </div>
          <div class="col-auto">
            <v-executer :loading="getting" :disabled="!canSave" :action="get">Sorgula</v-executer>
          </div>
          <div v-if="authDownloadExcel" class="col-auto">
            <v-executer :loading="gettingExcel" :disabled="!canSave" :action="getExcel">Excel</v-executer>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-sm bordered-header">
          <thead>
            <template v-if="($safe(data,'Harekets') || []).length > 0">
              <tr>
                <td class="text-danger font-weight-bolder text-right" colspan="6">Önceki Devir</td>
                <td class="text-right">{{ $safe(data,'OncekiDevirTahsil') }}</td>
                <td class="text-right">{{ $safe(data,'OncekiDevirTediye') }}</td>
                <td colspan="5"></td>
              </tr>
              <tr>
                <td class="text-danger font-weight-bolder text-right" colspan="6">Önceki Bakiye</td>
                <td class="text-right">{{ $safe(data,'OncekiBakiye') }}</td>
                <td colspan="6"></td>
              </tr>
            </template>
            <tr>
              <th></th>
              <th class="text-nowrap">Tarih</th>
              <th class="text-nowrap">Fiş No</th>
              <th class="text-nowrap">Tip</th>
              <th class="text-nowrap">Açıklama</th>
              <th class="text-nowrap">TMS Açıklama</th>
              <th class="text-right text-nowrap">Tahsil</th>
              <th class="text-right text-nowrap">Tediye</th>
              <th class="text-right text-nowrap">Bakiye</th>
              <th class="text-nowrap">Proje Kodu</th>
              <th class="text-nowrap">Belge Türü</th>
              <th class="text-nowrap">Plasiyer</th>
              <th class="text-nowrap">Rapor Kodu</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d,i) in ($safe(data,'Harekets') || [])" :key="i">
              <td>
                <div class="d-flex align-items-center justify-content-end w-100 g-50">
                  <button class="btn btn-xs btn-icon btn-flat-primary" v-on:click="print({FIS_NO:d.FisNo,TIP:d.Tip,SIRA:d.Sira})">
                    <feather-icon icon="PrinterIcon"></feather-icon> 
                  </button>
                  <button class="btn btn-xs btn-icon btn-flat-secondary" v-on:click="printTediye({FIS_NO:d.FisNo,TIP:d.Tip,SIRA:d.Sira})">
                    <feather-icon icon="PrinterIcon"></feather-icon> 
                  </button>
                </div>
              </td>
              <td class="text-nowrap">{{ $safe(d,'Tarih') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'FisNo') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'Tip') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'Aciklama') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'TMSVaultDescription') || '-' }}</td>
              <td class="text-nowrap text-right">{{ $safe(d,'Tahsil') || '-' }}</td>
              <td class="text-nowrap text-right">{{ $safe(d,'Tediye') || '-' }}</td>
              <td class="text-nowrap text-right">{{ $safe(d,'Bakiye') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'ProjeKodu') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'BelgeTuru') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'PlasiyerAdi') || '-' }}</td>
              <td class="text-nowrap">{{ $safe(d,'KasaRaporKodu') || '-' }}</td>
            </tr>
            <template v-if="($safe(data,'Harekets') || []).length > 0">
              <tr>
                <td class="text-nowrap font-weight-bolder text-right border-top-3" colspan="6">Kasa Hesabı</td>
                <td class="text-right border-top-3">{{ $safe(data,'KasaHesabiTahsil') }}</td>
                <td class="text-right border-top-3">{{ $safe(data,'KasaHesabiTediye') }}</td>
                <td class="border-top-3" colspan="5"></td>
              </tr>
              <tr>
                <td class="text-nowrap font-weight-bolder text-right" colspan="6">Kasa Toplam Hesabı</td>
                <td class="text-right">{{ $safe(data,'KasaToplamHesabiTahsil') }}</td>
                <td class="text-right">{{ $safe(data,'KasaToplamHesabiTediye') }}</td>
                <td colspan="5"></td>
              </tr>
              <tr>
                <td class="text-nowrap font-weight-bolder text-right" colspan="6">Devreden</td>
                <td class="text-right">{{ $safe(data,'Devreden') }}</td>
                <td colspan="6"></td>
              </tr>
            </template>
            <tr v-if="($safe(data,'Harekets') || []).length == 0">
              <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
import NetsisAccountantApi from '@/api/netsis-accountant'
import moment from 'moment'
import NetsisOperationsApi from '@/api/netsis-operations'
import { printFis } from '../vault-actions/components/fis/print-fis.js'
import { printTediyeFis } from '../vault-actions/components/fis/print-tediye-fis.js';
import Auth from '@/utilities/auth'
import Additional from '@/utilities/additional'

export default {
  components:{
    BCard,
    BOverlay
  },
  data(){
    return {
      data:{},
      getting: false,
      gettingExcel: false,
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      vault: null,
      vaults:[],
      kasaList:[],
      kasaLoading: false,
      types:[
          {value:'C',name:'Cari'},
          {value:'B',name:'Banka'},
          {value:'M',name:'Muhtelif'},
          {value:'F',name:'Fatura'},
      ],
      type:[],
    }
  },
  mounted(){
    this.getKasaList()
  },
  methods:{
    get(){
      this.getting = true
      NetsisAccountantApi.Report.getKasaReport({
        StartDate: this.startDate,
        EndDate: this.endDate,
        VaultCode: this.vault?.KSMAS_KOD,
        Types:(this.type || []).map(v => v.value)
      }).then(res => {
        this.data = res.data.Data
        this.getting = false
      }).catch(err => {
        this.getting = false
      })
    },
    getExcel(){
      this.gettingExcel = true
      NetsisAccountantApi.Report.getKasaReportExcel({
        StartDate: this.startDate,
        EndDate: this.endDate,
        VaultCode: this.vault?.KSMAS_KOD,
        Types:(this.type || []).map(v => v.value)
      }).then(res => {
        this.gettingExcel = false
        this.data = res.data.Data
        Additional.DownloadTab(this.data)
      }).catch(err => {
        this.gettingExcel = false
      })
    },
    getKasaList(){
        this.kasaLoading = true
        NetsisOperationsApi.GetKasaList().then(res => {
          this.kasaList = res.data.Data
          this.kasaLoading = false
        }).catch(err=> {
          console.log(err)
          this.kasaLoading = false
        })
    },
    printTediye(i){
      if(i.FIS_NO && i.TIP && i.SIRA){
        NetsisOperationsApi.TediyeFis(i.FIS_NO,i.TIP,i.SIRA).then(res => {
          if(res.data.Success){
              printTediyeFis(res.data.Data)
          }else{
              this.$result(res)
          }
        }).catch(err => {
          this.$result(null,err)
        })
      }
    },
    print(i){
      if(i.FIS_NO){
        let api = null
        if(i.TIP == 'C') api = NetsisOperationsApi.CariFis
        else if(i.TIP == 'B') api = NetsisOperationsApi.BankaFis
        else if(i.TIP == 'M') api = NetsisOperationsApi.MuhtelifFis
        else if(i.TIP == 'F') api = NetsisOperationsApi.FaturaFisTediye
        if(api){
          api(i.FIS_NO,i.SIRA).then(res => {
            if(res.data.Success){
              printFis(res.data.Data)
            }else{
              this.$result(res)
            }
          }).catch(err => {
              this.$result(null,err)
          })
        }
      }
    },
  },
  computed:{
    authDownloadExcel(){
      return Auth.hasRole(['VAULT_REPORT_DOWNLOAD_EXCEL'])
    },
    canSave(){
      return this.startDate && this.endDate && this.vault?.KSMAS_KOD
    }
  }
}
</script>